<!-- src/views/LotteryTable.vue -->
<template>
  <div class="lottery-container">
    <h1>🐴 2026丙午马年 · 六合彩属性对照表</h1>

    <!-- 生肖号码对照表 -->
    <div class="table-section">
      <h2>📅 十二生肖号码属性对照</h2>
      <table class="zodiac-table">
        <tbody>
          <tr v-for="item in zodiacNumbers" :key="item.shengxiao">
            <td class="zodiac-name">
              {{ item.shengxiao }}
              <img
                :src="iconMap.get(item.shengxiao)"
                :alt="item.shengxiao"
                class="zodiac-icon"
              />
              [冲 {{ item.clash }}]
            </td>
            <td class="numbers" colspan="2">
              <span
                v-for="num in item.numbers"
                :key="num"
                class="number-tag"
                :style="{ backgroundColor: getNumberColor(num) }"
              >
                {{ num }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 五行对照表 -->
    <div class="table-section">
      <h2>⚛️ 五行对照表</h2>
      <table class="attribute-table">
        <tbody>
          <tr v-for="(numbers, element) in wuxingMap" :key="element">
            <td class="attribute-name">{{ element }}</td>
            <td class="numbers">
              <span
                v-for="num in numbers"
                :key="num"
                class="number-tag"
                :style="{ backgroundColor: getNumberColor(num) }"
              >
                {{ num }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 波色对照表 -->
    <div class="table-section">
      <h2>🎨 波色对照表</h2>
      <table class="attribute-table">
        <tbody>
          <tr v-for="(numbers, bose) in boseMap" :key="bose">
            <td class="attribute-name">{{ bose }}波</td>
            <td class="numbers">
              <span
                v-for="num in numbers"
                :key="num"
                class="number-tag"
                :style="{ backgroundColor: getBoseColor(bose) }"
              >
                {{ num }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 合数单双表 -->
    <div class="table-section">
      <h2>🔢 合数单双对照表</h2>
      <table class="attribute-table">
        <tbody>
          <tr v-for="(numbers, type) in heshuMap" :key="type">
            <td class="attribute-name">合数{{ type }}</td>
            <td class="numbers">
              <span
                v-for="num in numbers"
                :key="num"
                class="number-tag"
                :style="{ backgroundColor: getNumberColor(num) }"
              >
                {{ num }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 生肖属性对照表 -->
    <div class="table-section">
      <h2>🐾 生肖属性对照表</h2>
      <table class="attribute-table">
        <tbody>
          <tr v-for="(zodiacs, prop) in _shuxingMap" :key="prop">
            <td class="attribute-name">{{ prop }}</td>
            <td class="zodiacs">
              <span v-for="zodiac in zodiacs" :key="zodiac" class="zodiac-tag">
                {{ zodiac }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { lotteryDataMap, iconMap, waveColorMap, lotteryData } from "./data";
// 从 lotteryDataMap 生成十二生肖号码数据
const zodiacNumbers = computed(() => {
  const zodiacMap = new Map();
  // 遍历所有号码，按生肖分组
  for (const [num, data] of lotteryDataMap.entries()) {
    if (!zodiacMap.has(data.shengxiao)) {
      zodiacMap.set(data.shengxiao, {
        shengxiao: data.shengxiao,
        clash: data.chong,
        numbers: [],
      });
    }
    zodiacMap.get(data.shengxiao).numbers.push(num);
  }
  return Array.from(zodiacMap.values());
});

// 从 lotteryDataMap 生成五行数据
const wuxingMap = computed(() => {
  const dataMap = {};
  for (const [num, data] of lotteryDataMap.entries()) {
    if (!dataMap[data.wuxing]) {
      dataMap[data.wuxing] = [num];
    } else {
      dataMap[data.wuxing].push(num);
    }
  }
  const sortedMap = {};
  ["金", "木", "水", "火", "土"].forEach((key) => {
    sortedMap[key] = dataMap[key];
  });
  return sortedMap;
});

// 从 lotteryDataMap 生成波色数据
const boseMap = computed(() => {
  const dataMap = {};
  for (const [num, data] of lotteryDataMap.entries()) {
    if (!dataMap[data.bose]) {
      dataMap[data.bose] = [num];
    } else {
      dataMap[data.bose].push(num);
    }
  }
  const sortedMap = {};
  ["红", "蓝", "绿"].forEach((key) => {
    sortedMap[key] = dataMap[key];
  });
  return sortedMap;
});

// 从 lotteryDataMap 生成合数单双数据
const heshuMap = computed(() => {
  const dataMap = {};
  for (const [num, data] of lotteryDataMap.entries()) {
    if (!dataMap[data.heshudanshuang]) {
      dataMap[data.heshudanshuang] = [num];
    } else {
      dataMap[data.heshudanshuang].push(num);
    }
  }
  const sortedMap = {};
  ["单", "双"].forEach((key) => {
    sortedMap[key] = dataMap[key];
  });
  return sortedMap;
});

function hasSameChars(str1, str2) {
  // 将字符串排序后比较
  const sorted1 = str1.split("").sort().join("");
  const sorted2 = str2.split("").sort().join("");
  return sorted1 === sorted2;
}
const _shuxingMap = computed(() => {
  const dataMap = {};
  for (const [num, data] of lotteryDataMap.entries()) {
    data.shuxing.forEach((shuxing) => {
      if (shuxing.includes("三合:") || shuxing.includes("六合:")) {
        const key = shuxing.split(":")[0];
        const value = `${data.shengxiao}${shuxing.split(":")[1]}`;
        if (dataMap[key]) {
          if (!dataMap[key].some((str) => hasSameChars(str, value))) {
            dataMap[key].push(value);
          }
        } else {
          dataMap[key] = [value];
        }
      } else {
        if (dataMap[shuxing]) {
          if (!dataMap[shuxing].includes(data.shengxiao)) {
            dataMap[shuxing].push(data.shengxiao);
          }
        } else {
          dataMap[shuxing] = [data.shengxiao];
        }
      }
    });
  }
  const sortMap = {};
  shuxingSortList.forEach((key) => {
    sortMap[key] = dataMap[key];
  });
  console.log(sortMap);
  return sortMap;
});

// 生肖属性数据（保持静态，因为这是分类定义）
const shuxingSortList = [
  "家禽",
  "野兽",
  "吉美",
  "凶丑",
  "阴性",
  "阳性",
  "单笔",
  "双笔",
  "天肖",
  "地肖",
  "白边",
  "黑中",
  "男肖",
  "女肖",
  "日肖",
  "夜肖",
  "前肖",
  "后肖",
  "大肖",
  "小肖",
  "左肖",
  "右肖",
  "朝肖",
  "夕肖",
  "胆大肖",
  "胆小肖",
  "三合",
  "六合",
  "琴",
  "棋",
  "书",
  "画",
  "春",
  "夏",
  "秋",
  "冬",
  "风",
  "雨",
  "雷",
  "电",
  "五福肖",
  "红肖",
  "蓝肖",
  "绿肖",
];

// 波色颜色映射（使用 lotteryDataMap 中的颜色，但需要浅色背景）
const boseColorMap = {
  红: "red", // 浅红色背景
  蓝: "blue", // 浅蓝色背景
  绿: "green", // 浅绿色背景
};

// 根据号码获取波色背景颜色
const getNumberColor = (num) => {
  const data = lotteryDataMap.get(num);
  if (data) {
    return boseColorMap[data.bose] || "#f5f0e8";
  }
  return "#f5f0e8"; // 默认背景色
};

// 根据波色类型获取颜色
const getBoseColor = (bose) => {
  return boseColorMap[bose] || "#f5f0e8";
};
</script>

<style lang="scss" scoped>
.zodiac-table {
  tbody {
    display: grid;
    grid-template-columns: 140px repeat(2, 1fr);
    text-align: center;
    tr {
      border: none;
    }
    td {
      border-bottom: none;
    }
    .zodiac-name {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 0;
    }
    .numbers {
      justify-content: center;
    }
  }
}

.zodiac-icon {
  width: 38px;
  height: 32px;
  vertical-align: middle;
  margin-right: 4px;
}

.number-tag {
  display: inline-block;
  border: 1px solid #e0d5c8;
  color: #4a4a4a;
  text-align: center;
  transition: all 0.2s;
}

/* 保持原有其他样式不变 */
.zodiac-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: #f0e9e0;
  border: 1px solid #d4c5b5;
  border-radius: 20px;
  color: #4a4a4a;
}

.lottery-container {
  margin: 0 auto;
  padding: 12px 0px;
  background: #faf7f2;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

h1 {
  text-align: center;
  color: #4a4a4a;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  border-bottom: 2px solid #d4c5b5;
  padding-bottom: 15px;
}

h2 {
  color: #5a5a5a;
  /* font-size: 1.3rem; */
  //   margin-bottom: 12px;
  padding-bottom: 12px;
  font-weight: 500;
  padding-left: 12px;
  border-bottom: 1px solid #eee;
}

.table-section {
  background: white;
  border-radius: 12px;
  padding: 12px 0 0;
  margin: 12px 0;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e8e0d5;
  border-radius: 8px;
  overflow: hidden;
}

th {
  background: #fff;
  color: #fff;
  font-weight: 500;
  padding: 12px 10px;
  text-align: left;
  /* font-size: 0.95rem; */
  border-bottom: 2px solid #d4c5b5;
}

td {
  padding: 12px 5px;
  border-bottom: 1px solid #ede5d9;
  vertical-align: top;
}

tr:last-child td {
  border-bottom: none;
}

.attribute-name {
  font-weight: 500;
  color: #5d4a36;
  width: 60px;
  text-align: center;
  white-space: nowrap;
  border-right: 1px solid #eee;
}

.numbers,
.zodiacs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.number-tag {
  display: inline-block;
  width: 17.46px;
  height: 17.46px;
  line-height: 17.46px;
  text-align: center;
  background: #f5f0e8;
  border: 1px solid #e0d5c8;
  font-size: 14px;
  color: #fff;
  /* min-width: 40px; */
  text-align: center;
}

.zodiac-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  font-size: 13px;
  background: #f0e9e0;
  border: 1px solid #d4c5b5;
  border-radius: 20px;
  color: #4a4a4a;
}

.special-value {
  color: #5d4a36;
  line-height: 1.6;
  /* font-size: 0.95rem; */
}
</style>